module.exports = __webpack_public_path__ + "img/logon.ad696e6e.webp";